module.exports = __webpack_public_path__ + "img/5.a532e838.svg";